import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rotated-list"

/*
<div class="flex flex-col items-center justify-center" data-controller="rotated-list" data-rotated-list-duration="3000">
  <span class="hidden text-sm" data-rotated-list-target="item">Resizing image...</span>
  <span class="hidden text-sm" data-rotated-list-target="item">Uploading image...</span>
  <span class="hidden text-sm" data-rotated-list-target="item">Running moderation...</span>
  <span class="hidden text-sm" data-rotated-list-target="item">Saving image...</span>
  <span class="hidden text-sm" data-rotated-list-target="item">Running some magic...</span>
</div>
*/

export default class extends Controller {
  static targets = ['item'];
  static values = {
    duration: { type: Number, default: 3000 }
  }

  connect() {
    this.hideItems();
    window.addEventListener('rotated-list:start', this.start.bind(this));
  }

  disconnect() {
    window.removeEventListener('rotated-list:start', this.start.bind(this));
  }

  start() {
    this.currentIndex = 0;
    this.showItem(this.currentIndex);

    setInterval(() => {
      this.currentIndex++;
      if (this.currentIndex >= this.itemTargets.length) {
        this.currentIndex = 0;
      }
      this.showItem(this.currentIndex);
    }, this.durationValue);
  }

  showItem(index) {
    this.hideItems();
    this.itemTargets[index].classList.remove('hidden');
  }

  hideItems() {
    this.itemTargets.forEach((item) => {
      item.classList.add('hidden');
    });
  }
}
